module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notDisplayableContent":"Not displayable content"},"fr":{"notDisplayableContent":"Contenu non affichable"}}')
  delete Component.options._Ctor
}
